import { map } from "lodash";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Container, Label } from "reactstrap";
import t from "utils/Lang";
import "./index.scss";

// The Roster component matches one of two different routes
// depending on the full pathname

const Settings = () => {
  const settingsMenu = [
    {
      id: 1,
      name: t().settings__zone_management,
      items: [
        {
          id: 1,
          name: t().settings__zone_configure,
          path: "/settings/zone/element",
        },
      ],
    },
    {
      id: 2,
      name: t().settings__user_management,
      items: [{ id: 1, name: t().settings__user, path: "/settings/users" }],
    },
    {
      id: 3,
      name: t().settings__status_management,
      items: [
        { id: 1, name: t().site_listing__status, path: "/settings/status" },
      ],
    },
    {
      id: 4,
      name: t().settings__custom_field,
      items: [{ id: 1, name: "Site", path: "/settings/custom-field" }],
    },
  ];
  return (
    <div className="sitebar-settings__menu">
      {settingsMenu.map((setting) => (
        <div className="sitebar-settings__item" key={`item-${setting.id}`}>
          <div className="sitebar-settings__item-name">{setting.name}</div>
          {setting.items && (
            <div className="sitebar-settings__item-element-container">
              {setting.items.map((settingItem) => (
                <div
                  className="sitebar-settings__item-element"
                  key={`item-${settingItem.id}`}
                >
                  <Link to={settingItem.path}>{settingItem.name}</Link>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Settings;
